module.exports = `${require.publicPath}NotoSansSC-Regular.ce219ad4.ttf`;